jQuery(function($){
	
	/* Document Ready */
	$(document).ready(function() {
        
        // Select2
        if($('.blog-sidebar').length){
            
            $('.blog-sidebar').find('select').each(function() {
                var dropdownParent = $(this).parent();
                $(this).select2({
                    dropdownParent: dropdownParent
                });
                 
            });
        }
        
        $('.popup-youtube, .popup-vimeo').magnificPopup({
            disableOn: 700,
            type: 'iframe',
            mainClass: 'mfp-fade',
            removalDelay: 160,
            preloader: false,
            fixedContentPos: false
        });
	});
    
        
    //Sidr
    $('#mobile-trigger').sidr({
        side: 'right',
        name: 'sidr',
        displace: false,
        source : function() {
            var sidrHtml;

            sidrHtml = '<div id="mobile-menu">';
            sidrHtml += '<span class="sidr__close" aria-label="Close Menu"></span>';

            sidrHtml += '<div class="sidr__inner">';

            sidrHtml += '<div class="sidr__mainnav">' + $('.site-navigation').html() + '</div>';


            if($('.site-header-subnav').length){
                sidrHtml += '<div class="sidr__subnav">' + $('.site-header-subnav .container-fluid').html() + '</div>';
            }

            sidrHtml += '</div>';
            sidrHtml += '</div>';

            return sidrHtml;
        },
        onOpen: function() {
            //alert('test');
            $( 'body' ).prepend( '<div class="sidr-overlay"></div>' );
        },
        onClose: function(){
            $( '.sidr-overlay' ).remove();
        }
    });
    $('.menu-item').find('.arrow').click(function(e) {
        e.preventDefault();
        $(this).toggleClass('active').next().slideToggle();
    });
    $('.sidr__close').click(function() {
        $.sidr('close','sidr');
    });
	
	
	$(document).ready(function () {
    $('.club-nav a').click(function (event) {
        event.preventDefault();
		$('.club-nav a').removeClass('active');
		$(this).addClass('active');
        $('.club-pane').hide(); // hide previous popup div
        var id = $(this).data("id"); // get the div id which to show
        $('#' + id).fadeIn(function () {  // show cuurent click link's popup
            $(this).show();
        })
    });
	
	
	//menu script
	
	 $('ul.sub-menu').parent().addClass('drop-down'); // Add Sub-Menu Class to insert personalized style
    $('li.drop-down > a:first-child').after('<div class="submenu-arrow"></div>'); // Add .menu-bullet in span to insert your arrow image background 
	
	$('div.submenu-arrow').on('click',function(){
		
		if($(this).hasClass('dropdown-open')){
			$(this).removeClass('dropdown-open');
		}else{
			$(this).addClass('dropdown-open');
		}
		
		$(this).siblings('ul').slideToggle();
		//$('.sub-menu').slideToggle();
		//$('.sub-menu').toggle();
		});
		
		$('.navbar-toggle').on('click',function(){
		$(this).children('span').toggleClass('active');	
		$(this).toggleClass('bggreen');	
		$('nav').toggleClass('bgblue');
		$('h1.site-logo').toggleClass('white');
		
	});
	var alterClass = function(){
		var ww = document.body.clientWidth;
		if(ww < 1199){
            $('body').addClass('mobile-break');
			$('nav').addClass('navbar-fixed-top');
		}if(ww >= 1200){
            $('body').removeClass('mobile-break');
			$('nav').removeClass('navbar-fixed-top bgblue');
			$('#mobilemenu').removeClass('in');
			$('.navbar-toggle').removeClass('bggreen');
			$('.navbar-toggle').children('span').removeClass('active');
			$('h1.site-logo').removeClass('white');
        };
	};
	
	$(window).resize(function(){
		
		alterClass();
		
	});
	alterClass();
	

})


$('#storyVid').on('hide.bs.modal', function(e) {    
    var $if = $(e.delegateTarget).find('iframe');
    var src = $if.attr("src");
    $if.attr("src", '/empty.html');
    $if.attr("src", src);
});

$('#play-button').on('click',function(){
	$(this).hide();
	$('#success-video iframe').show();
})

//


/*
*  new_map
*
*  This function will render a Google Map onto the selected jQuery element
*
*  @type	function
*  @date	8/11/2013
*  @since	4.3.0
*
*  @param	$el (jQuery element)
*  @return	n/a
*/

function new_map( $el ) {
	
	// var
	var $markers = $el.find('.marker');
	
	
	// vars
	var args = {
		zoom		: 14,
		center		: new google.maps.LatLng(0, 0),
		mapTypeId	: google.maps.MapTypeId.ROADMAP
	};
	
	
	// create map	        	
	var map = new google.maps.Map( $el[0], args);
	
	
	// add a markers reference
	map.markers = [];
	
	
	// add markers
	$markers.each(function(){
		
    	add_marker( $(this), map );
		
	});
	
	
	// center map
	center_map( map );
	
	
	// return
	return map;
	
}

/*
*  add_marker
*
*  This function will add a marker to the selected Google Map
*
*  @type	function
*  @date	8/11/2013
*  @since	4.3.0
*
*  @param	$marker (jQuery element)
*  @param	map (Google Map object)
*  @return	n/a
*/

function add_marker( $marker, map ) {

	// var
	var latlng = new google.maps.LatLng( $marker.attr('data-lat'), $marker.attr('data-lng') );

	// create marker
	var marker = new google.maps.Marker({
		position	: latlng,
		map			: map
	});

	// add to array
	map.markers.push( marker );

	// if marker contains HTML, add it to an infoWindow
	if( $marker.html() )
	{
		// create info window
		var infowindow = new google.maps.InfoWindow({
			content		: $marker.html()
		});

		// show info window when marker is clicked
		google.maps.event.addListener(marker, 'click', function() {

			infowindow.open( map, marker );

		});
	}

}

/*
*  center_map
*
*  This function will center the map, showing all markers attached to this map
*
*  @type	function
*  @date	8/11/2013
*  @since	4.3.0
*
*  @param	map (Google Map object)
*  @return	n/a
*/

function center_map( map ) {

	// vars
	var bounds = new google.maps.LatLngBounds();

	// loop through all markers and create bounds
	$.each( map.markers, function( i, marker ){

		var latlng = new google.maps.LatLng( marker.position.lat(), marker.position.lng() );

		bounds.extend( latlng );

	});

	// only 1 marker?
	if( map.markers.length == 1 )
	{
		// set center of map
	    map.setCenter( bounds.getCenter() );
	    map.setZoom( 10 );
	}
	else
	{
		// fit to bounds
		map.fitBounds( bounds );
	}

}

/*
*  document ready
*
*  This function will render each map when the document is ready (page has loaded)
*
*  @type	function
*  @date	8/11/2013
*  @since	5.0.0
*
*  @param	n/a
*  @return	n/a
*/
// global var
var map = null;

$(document).ready(function(){

	$('.acf-map').each(function(){

		// create map
		map = new_map( $(this) );

	});

});




//
});